import React, { useEffect } from "react";

import { Select, Input } from "antd";

import { connect } from "react-redux";

import {
    setRelationship,
    setRelationshipName,
    setRelationshipRemark,
    getAllowedRelationships,
    cleanup,
} from "rx/selectrelationship";

function SelectRelationshipRxComponent(props) {
    useEffect(() => {
        props.getAllowedRelationships();
    }, []);

    return (
        <>
            <Select
            {...props}
            size="large"
            value={props.relationshipName}
            onChange={(relationship) => {
                props.setRelationship(relationship.split("|")[0]);
                props.setRelationshipName(relationship.split("|")[1]);
            }}
            >
            {props.allowedRelationships &&
                props.allowedRelationships.map((record) => {
                return (
                    <Select.Option
                    value={record.code + "|" + record.value}
                    key="idx"
                    >
                    {record.value}
                    </Select.Option>
                );
                })}
            </Select>

            {props.relationshipName === "Others" && (
            <Input
                style={{ marginTop: "5px" }}
                size="large"
                onChange={(e) => {
                props.setRelationshipRemark(e.target.value);
                }}
                defaultValue={props.relationshipRemark}
            />
            )}
        </>
    );
}

const mapStateToProps = (state) => {
    return {
        relationship: state.selectRelationship.relationship,
        relationshipName: state.selectRelationship.relationshipName,
        relationshipRemark: state.selectRelationship.relationshipRemark,
        allowedRelationships: state.selectRelationship.allowedRelationships,
    };
};
  
const mapDispatchToProps = (dispatch) => {
    return {
        cleanup: () => dispatch(cleanup()),
        setRelationship: (relationship) => dispatch(setRelationship(relationship)),
        setRelationshipName: (relationshipName) => dispatch(setRelationshipName(relationshipName)),
        setRelationshipRemark: (relationshipRemark) => dispatch(setRelationshipRemark(relationshipRemark)),
        getAllowedRelationships: () => dispatch(getAllowedRelationships()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SelectRelationshipRxComponent);
